export default {
  userInfo: state => state.userInfo || {},
  permissions: state => state.permissions || [],
  isDealer: (state, getters) => getters.userInfo.data_type === '4',
  // 客户门户相关
  isCustomer: state => state.isCustomer,
  customerProjectId: state => state.customerProjectId,
  // 判断是否只有bzmj权限（客户账号特征）
  hasOnlyBzmjPermission: state => {
    const permissions = state.allPermissions || []
    if (permissions.length === 0) return false
    // 检查是否所有权限都是 /bzmj 开头
    return permissions.every(p => p.uri && p.uri.startsWith('/bzmj'))
  }
}
